<template>
  <div class="fab" :class="{ 'is-floating': isFloating }">
    <slot></slot>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isFloating: false,
    }
  },
  mounted() {
    window.addEventListener('scroll', this.update)
    this.$el.parentElement.classList.add('fab-wrapper')
    this.$nextTick(this.update)

    // make sure it's updated (especially important for initial fetch)
    this.intervalId = setInterval(this.update, 250)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.update)
    clearInterval(this.intervalId)
  },
  methods: {
    update() {
      const rect = this.getWrapper().getBoundingClientRect()
      const bottomDistance = window.innerHeight - rect.bottom
      // console.debug(` => fab's parent distance to bottom: ${bottomDistance}`)

      if (bottomDistance < 0) {
        this.isFloating = true
      } else {
        this.isFloating = false
      }
    },
    getWrapper() {
      return this.$el.parentElement
    },
  },
}
</script>

<style lang="scss">
.fab-wrapper {
  position: relative;
}
.fab {
  display: inline-block;
  position: absolute;
  bottom: 20px;
  right: 25px;

  &.is-floating {
    position: fixed;
    right: 35px;
    z-index: 999;
  }
}
</style>
